import { BubbleData } from '../../types/bubbleData'
import { BubbleSeries } from '../../types/bubbleSeries'
import { INSUFFICIENT_BOUND, DEFAULT_CHART_HEIGHT_IN_PX } from './constants'

const MINIMUM_VIEWABLE_RADIUS = 20

const seriesHasResult = (series: BubbleSeries) =>
  !series.noData && series.supported && series.size >= INSUFFICIENT_BOUND

const resolveMinRadiusInPercentage = (bubbleData: BubbleData[]) => {
  let minRadius = Number.MAX_VALUE

  bubbleData!.forEach((bubble) => {
    bubble.series.filter(seriesHasResult).forEach((series) => {
      const { radius } = series

      if (radius < minRadius && radius > 0) {
        minRadius = radius
      }
    })
  })

  return ((Math.max(minRadius, MINIMUM_VIEWABLE_RADIUS) * 2) / DEFAULT_CHART_HEIGHT_IN_PX) * 100
}

export default resolveMinRadiusInPercentage
